<template>
  <div class="survey-popup-overlay" v-if="showPopup">
    <div class="survey-popup-box">
      <div class="survey-popup-header">
        <h3>{{ config.popup_title || survey.title || '问卷调研' }}</h3>
        <span class="close-btn" @click="closePopup">&times;</span>
      </div>
      <div class="survey-popup-body">
        <p>{{ config.popup_content || survey.description || '我们诚挚邀请您参与一份简短的问卷调研，以帮助我们提供更好的服务。您的反馈对我们非常重要！' }}</p>
      </div>
      <div class="survey-popup-footer">
        <label class="no-remind-label">
          <input type="checkbox" v-model="noRemind"> 不再提醒
        </label>
        <div class="footer-btns">
          <button class="btn-cancel" @click="closePopup">暂不参与</button>
          <button class="btn-confirm" @click="goSurvey">立即参与</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPopupSurvey } from '../http.js';

export default {
  name: 'SurveyPopup',
  data() {
    return {
      showPopup: false,
      survey: null,
      is_filled: false,
      noRemind: false,
      config: {
        popup_daily_limit: 1,
        popup_cooldown_days: 3,
        is_show_popup: 1,
        popup_title: '问卷调研',
        popup_content: '我们诚挚邀请您参与一份简短的问卷调研，您的反馈对我们非常重要！',
        show_after_filled: 0
      }
    }
  },
  mounted() {
    this.checkAndFetchSurvey();
  },
  methods: {
    checkAndFetchSurvey() {
      // Fetch survey configuration and ongoing survey
      getPopupSurvey().then(res => {
        if (res.status && res.data && res.data.survey) {
          this.survey = res.data.survey;
          this.is_filled = res.data.is_filled;
          this.config = Object.assign(this.config, res.data.config);
          
          if (this.shouldShowPopup(this.survey.id)) {
            this.showPopup = true;
            this.recordPopup(this.survey.id);
          }
        }
      });
    },
    shouldShowPopup(surveyId) {
      if (this.config.is_show_popup == 0) {
        return false;
      }
      
      let userToken = this.$storage.get("userToken");
      if (!userToken) {
        return false;
      }

      if (this.is_filled && this.config.show_after_filled == 0) {
        return false;
      }

      // 0. Check Never Remind
      let neverKey = `survey_popup_never_${surveyId}`;
      if (this.$storage.get(neverKey)) {
        return false;
      }

      // 1. Check Cooldown
      let cooldownKey = `survey_popup_cooldown_${surveyId}`;
      let lastCloseTime = this.$storage.get(cooldownKey);
      if (lastCloseTime) {
        let now = new Date().getTime();
        let daysPassed = (now - lastCloseTime) / (1000 * 60 * 60 * 24);
        if (daysPassed < this.config.popup_cooldown_days) {
          return false; // Still in cooldown
        }
      }

      // 2. Check Daily Limit
      let dailyLimitKey = `survey_popup_daily_${surveyId}`;
      let dailyData = this.$storage.get(dailyLimitKey);
      let todayStr = new Date().toDateString();
      
      if (dailyData) {
        if (dailyData.date === todayStr) {
          if (this.config.popup_daily_limit > 0 && dailyData.count >= this.config.popup_daily_limit) {
            return false; // Reached daily limit
          }
        } else {
          // Reset for new day (will be done in recordPopup, so we just pass here)
        }
      }

      return true;
    },
    recordPopup(surveyId) {
      let dailyLimitKey = `survey_popup_daily_${surveyId}`;
      let dailyData = this.$storage.get(dailyLimitKey);
      let todayStr = new Date().toDateString();
      
      if (dailyData && dailyData.date === todayStr) {
        dailyData.count += 1;
      } else {
        dailyData = { date: todayStr, count: 1 };
      }
      this.$storage.set(dailyLimitKey, dailyData);
    },
    closePopup() {
      if (this.survey) {
        if (this.noRemind) {
          let neverKey = `survey_popup_never_${this.survey.id}`;
          this.$storage.set(neverKey, true);
        } else {
          let cooldownKey = `survey_popup_cooldown_${this.survey.id}`;
          this.$storage.set(cooldownKey, new Date().getTime());
        }
      }
      this.showPopup = false;
    },
    goSurvey() {
      this.showPopup = false;
      this.$router.push({ name: 'survey', params: { id: this.survey.id } });
    }
  }
}
</script>

<style scoped>
.survey-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.survey-popup-box {
  width: 400px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}
.survey-popup-header {
  background: #f5f7fa;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e4e7ed;
}
.survey-popup-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}
.close-btn {
  font-size: 20px;
  color: #909399;
  cursor: pointer;
}
.close-btn:hover {
  color: #f56c6c;
}
.survey-popup-body {
  padding: 20px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}
.survey-popup-footer {
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e4e7ed;
}
.no-remind-label {
  font-size: 13px;
  color: #909399;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.no-remind-label input {
  margin-right: 5px;
}
.footer-btns button {
  padding: 8px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  margin-left: 10px;
}
.btn-cancel {
  background: #fff;
  border: 1px solid #dcdfe6 !important;
  color: #606266;
}
.btn-cancel:hover {
  color: #409eff;
  border-color: #c6e2ff !important;
  background-color: #ecf5ff;
}
.btn-confirm {
  background: #409eff;
  color: #fff;
}
.btn-confirm:hover {
  background: #66b1ff;
}
</style>
